// extracted by mini-css-extract-plugin
export var button = "_cg-2";
export var iconWrapper = "_cg-0";
export var investigatingIcon = "_cg-1";